import { ProtectedComponent } from '@components'

import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { ConnectShineBanner } from '@features/shineBanking/elements/ConnectShineBanner'

import { Scope } from '../../../../../../../../enums/scope'
import * as Styled from '../../styles'

interface ShineBannerProps {
  shouldShow?: boolean
  withBottomMargin?: boolean
}

export const ShineBanner = ({ shouldShow, withBottomMargin }: ShineBannerProps): ReactElement | null => {
  if (!shouldShow) {
    return null
  }

  return (
    <Styled.BannerWrapper>
      <ProtectedComponent scopes={Scope.IdentityMergeWrite}>
        <ConnectShineBanner />
        {withBottomMargin && <Space size="s24" />}
      </ProtectedComponent>
    </Styled.BannerWrapper>
  )
}
